module.exports = __webpack_public_path__ + "static/media/ex16.fa4e5744.jpg";